export default "__VITE_ASSET__CA4OszmR__"